import GenericAction from '@Actions/generic-action';
import { Actions } from '@Context/common/general/context';
import { AnalyticsEvents } from '@Enums';
import { getAuth, isSignInWithEmailLink, signInWithEmailLink } from 'firebase/auth';
export default class LoginWithLink extends GenericAction {
  runAction() {
    const Action = async () => {
      try {
        const firebaseAuth = getAuth();
        await isSignInWithEmailLink(firebaseAuth, this._payload.loginLink);
        const response = await signInWithEmailLink(firebaseAuth, this._payload.email, this._payload.loginLink);
        this._dispatch({
          type: Actions.AppActions.AnalyticsEvent,
          payload: { type: AnalyticsEvents.user_login_with_link }
        });
        this._dispatch({
          type: Actions.CoreActions.UpdateState,
          payload: {
            user: {
              authenticated: true,
              email: response.user.email,
            },
          },
        });
        this._state.auth.events.loginSuccess.emit();
        super.onSuccess(response);
      } catch (error) {
        super.onError(error);
      }
    };
    Action();
  }
}